import React, { useState } from 'react';
import useFetch from '../../../hooks/fetchMSSQL-hook';

export default function VpnSqlPanel({ nodes }) {
  const { fetchMssqlApi } = useFetch();
  const [open, setOpen] = useState(false);
  const [sql, setSql] = useState('SELECT * FROM tblSettings;');
  const [running, setRunning] = useState(false);
  const [results, setResults] = useState([]);
  const [completed, setCompleted] = useState(0);
  const [total, setTotal] = useState(0);
  const [exportError, setExportError] = useState('');

  const execute = async () => {
    if (running || !sql.trim() || !nodes.length) return;
    if (!window.confirm(`Wykonać SQL na ${nodes.length} automatach? Polecenia zmieniające dane zostaną zastosowane na każdej dostępnej maszynie.\n\n${sql}`)) return;
    const targets = nodes.slice();
    const query = sql;
    setRunning(true);
    setCompleted(0);
    setTotal(targets.length);
    setResults([]);
    let next = 0;
    const worker = async () => {
      while (next < targets.length) {
        const index = next++;
        const node = targets[index];
        const result = {
          index,
          machineNo: node.vdmName || node.givenName || node.name || String(node.id),
          clientId: node.customerAbbr ? String(node.customerAbbr).trim().toLowerCase() : null,
          nodeIp: (node.ipAddresses || []).find(ip => /^100\./.test(ip)) || '',
        };
        if (!node.online || !result.nodeIp) {
          result.error = !node.online ? 'Automat offline — pominięto.' : 'Brak adresu IPv4 VPN — pominięto.';
        } else {
          await new Promise(resolve => {
            const fail = error => {
              result.error = (error && error.response && error.response.data && error.response.data.error) || 'Błąd połączenia z API.';
              resolve();
            };
            fetchMssqlApi('user/vpn-sql', {
              method: 'POST', data: { nodeIp: result.nodeIp, sql: query },
              hideNotification: true, showLoader: false, isErrorAcceptable: true,
            }, response => {
              if (response && response.success) result.output = response.output;
              else result.error = (response && response.error) || 'Brak odpowiedzi serwera.';
              resolve();
            }, fail, () => fail());
          });
        }
        setResults(previous => [...previous, result].sort((a, b) => a.index - b.index));
        setCompleted(previous => previous + 1);
      }
    };
    try {
      await Promise.all(Array.from({ length: Math.min(4, targets.length) }, worker));
    } finally {
      setRunning(false);
    }
  };

  const exportCsv = () => {
    try {
      const cell = value => {
        const text = String(value == null ? '' : value);
        return '"' + (/^[=+@-]/.test(text) ? "'" : '') + text.replace(/"/g, '""') + '"';
      };
      const rows = [['Numer automatu', 'clientId', 'IP', 'Status', 'Wynik / błąd'],
        ...results.map(row => [row.machineNo, row.clientId, row.nodeIp, row.error ? 'Błąd / pominięto' : 'OK', row.error || row.output || 'Brak wierszy'])];
      const url = URL.createObjectURL(new Blob(['\uFEFF' + rows.map(row => row.map(cell).join(';')).join('\r\n')], { type: 'text/csv;charset=utf-8;' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = 'vpn-sql.csv';
      link.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      setExportError('');
    } catch (_) {
      setExportError('Nie udało się pobrać CSV. Spróbuj ponownie.');
    }
  };

  return (
    <div className="card shadow-sm border-0 mb-4">
      <div className="card-header bg-white d-flex justify-content-between align-items-center">
        <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => setOpen(!open)} aria-expanded={open}>
          <i className="fas fa-database mr-2" /> SQL na wszystkich automatach
        </button>
        {total > 0 && <span className="small">{running ? 'Wykonywanie' : 'Zakończono'}: {completed}/{total}</span>}
      </div>
      {open && <div className="card-body">
        <p className="small text-muted">SQL zostanie wykonany w bazie multivend wszystkich automatów z listy VPN, niezależnie od filtra i strony. Automaty offline zostaną pokazane jako pominięte. clientId pochodzi z przypisania klienta w portalu; brak przypisania jest oznaczony w tabeli.</p>
        <label htmlFor="vpn-sql-query">Polecenie SQL</label>
        <textarea id="vpn-sql-query" className="form-control text-monospace mb-3" rows={5} maxLength={20000} value={sql} onChange={event => setSql(event.target.value)} disabled={running} />
        <button type="button" className="btn btn-primary btn-sm mr-2" disabled={running || !sql.trim() || !nodes.length} onClick={execute}>
          {running ? 'Wykonywanie SQL...' : `Uruchom na wszystkich (${nodes.length})`}
        </button>
        <button type="button" className="btn btn-outline-secondary btn-sm" disabled={running || !results.length} onClick={exportCsv}>Pobierz CSV</button>
        {exportError && <div role="alert" className="alert alert-danger mt-2">{exportError}</div>}
        {results.length > 0 && <div className="table-responsive mt-3" style={{ maxHeight: '600px' }}>
          <table className="table table-sm table-bordered">
            <thead><tr><th>Numer automatu</th><th>clientId</th><th>IP</th><th>Status</th><th>Wynik SQL / błąd</th></tr></thead>
            <tbody>{results.map(row => <tr key={row.index}>
              <td>{row.machineNo}</td><td>{row.clientId || 'Brak przypisania'}</td><td>{row.nodeIp || '—'}</td>
              <td>{row.error ? 'Błąd / pominięto' : 'OK'}</td>
              <td><pre className={`mb-0 ${row.error ? 'text-danger' : ''}`} style={{ whiteSpace: 'pre-wrap', minWidth: '300px', maxHeight: '240px', overflow: 'auto' }}>{row.error || row.output || 'Polecenie wykonano — brak wierszy.'}</pre></td>
            </tr>)}</tbody>
          </table>
        </div>}
      </div>}
    </div>
  );
}
